<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="Dashboard" />
        <!-- Container-fluid starts-->
        <div class="container-fluid"> 
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <h5 style="width: 100%; text-align: left;">Welcome to QuickCV Admin Panel!</h5>
                            <p class="mt-2 main-title text-right">Subscription</p>
                            <div>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/subscription/user/list?page=1&perPage=25">
                                                <div class="title">User
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">20</div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-4 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/subscription/payment-initiated/list?page=1&perPage=25">
                                                <div class="title">Payment Initiated
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">55</div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/subscription/activated/list?page=1&perPage=25">
                                                <div class="title">Paid & Activated
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">12</div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div class="mt-4">
                                <p class="mt-5 main-title">System</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-3">
                                        <router-link to="/system/payment-log?page=1&perPage=25">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Payment
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">25</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 margin-y-axis">
                                        <router-link to="/system/package">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Package
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">32</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 margin-botton">
                                        <router-link to="/system/coin-feature">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Coin Feature
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">07</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3">
                                        <router-link to="/system/coupon">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Coupon
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">12</div>
                                            </div>
                                        </div>
                                    </router-link>
                                    </div>
                                </div>

                                <p class="mt-5 main-title text-right">Operation</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">CV Tracking Label</div>
                                                <div class="count">88</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <router-link to="/operation/cv-tracking-label">
                                                    <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Digital Skill</div>
                                                <div class="count">78</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <router-link to="/operation/digital-skill">
                                                    <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Language</div>
                                                <div class="count">54</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <router-link to="/operation/language">
                                                    <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div style="width: 100%;" v-if="!loading && !error">
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/location/shelter/list">
                                                <div class="title">Shelter
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.shelter">{{ count_list.shelter }}</div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-4 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/house/list">
                                                <div class="title">Occupancy
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.total_member_sum">{{ count_list.total_member_sum }}</div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/house/list">
                                                <div class="title">House
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.home">{{ count_list.home }}</div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div> 

                                <p class="mt-5 main-title">Demographic ({{ count_list.total_member_sum }})</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Male</div>
                                                <div class="count" v-if="count_list.male">{{ count_list.male }}</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;" v-b-modal.modal-center @click="getDemographic('Male')">Details</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Female</div>
                                                <div class="count" v-if="count_list.female">{{ count_list.female }}</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <div style="text-align: center; font-size: medium; padding: 6px; cursor: pointer;" v-b-modal.modal-center @click="getDemographic('Female')">Details</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Children</div>
                                                <div class="count" v-if="count_list.child">{{ count_list.child }}</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <div style="text-align: center; font-size: medium; padding: 6px; cursor: pointer;" v-b-modal.modal-center @click="getDemographic('Children')">Details</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="mt-5 main-title text-right">Health Condition</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-3">
                                        <router-link :to="{ path: '/house/list', query: { health_condition: 'Good', page:1, perPage:25 } }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Good
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.good">{{ count_list.good }}</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 margin-y-axis">
                                        <router-link :to="{ path: '/house/list', query: { health_condition: 'Sick',page:1, perPage:25 } }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Sick
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.sick">{{ count_list.sick }}</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 margin-botton">
                                        <router-link :to="{ path: '/house/list', query: { health_condition: 'Disability',page:1, perPage:25 } }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Disability
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.disability">{{ count_list.disability }}</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3">
                                        <router-link :to="{ path: '/house/list', query: { health_condition: 'Pregnant' ,page:1, perPage:25} }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Pregnant
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.pregnant">{{ count_list.pregnant }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                    </div>
                                </div>

                                <p class="mt-5 main-title">House Condition ({{count_list.home  }})</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-3 w-100">
                                        <router-link :to="{ path: '/house/list', query: { house_condition: 'Multi-Stored' ,page:1, perPage:25} }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Multi-Stored
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.multi_stored_home">{{ count_list.multi_stored_home }}</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 w-100 margin-y-axis">
                                        <router-link :to="{ path: '/house/list', query: { house_condition: 'Concrete',page:1, perPage:25} }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Concrete
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.concrete_home">{{ count_list.concrete_home }}</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 w-100 margin-botton">
                                        <router-link :to="{ path: '/house/list', query: { house_condition: 'Tin-Shade' ,page:1, perPage:25} }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Tin-Shade
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.tin_home">{{ count_list.tin_home }}</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 w-100">
                                        <router-link :to="{ path: '/house/list', query: { house_condition: 'Mud-House' ,page:1, perPage:25} }">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Mud-House
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="count_list.mud_home">{{ count_list.mud_home }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                    </div>
                                </div>

                               
                            </div>
                            <div v-else>
                                <loader/>
                            </div> -->
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <!-- Demographic Details -->
        <b-modal id="modal-center" ref="modal" centered :title="demographic_title" size="s" hide-footer> 
            <div v-if="demographic_title !== 'Children'">
                <div class="row mt-2">
                    <div class="col-sm-12">
                        <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Good:</span>
                        <span v-if="details.good">{{details.good}}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12">
                        <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Sick:</span>
                        <span v-if="details.sick">{{details.sick}}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12">
                        <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Disability:</span>
                        <span v-if="details.disabled">{{ details.disabled }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-3" v-if="demographic_title === 'Female'">
                    <div class="col-sm-12">
                        <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Pregnant:</span>
                        <span v-if="details.pregnant">{{ details.pregnant }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-3" v-if="demographic_title == 'Female'">
                    <div class="col-sm-12">
                        <div style="display: flex; gap: 20px; font-size: medium;">
                            <span style="width: 100px;">Menstruation:</span>
                            <span v-if="details.menstruation">{{ details.menstruation }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-sm-6">
                        <p style="display: flex; gap: 20px; font-size: medium;font-weight: 500">Male</p>
                        <div class="row mt-2">
                            <div class="col-sm-12">
                                <div style="display: flex; gap: 20px; font-size: medium;">
                                    <span style="width: 100px;">Good:</span>
                                    <span v-if="details.male.good>=0">{{details.male.good}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div style="display: flex; gap: 20px; font-size: medium;">
                                    <span style="width: 100px;">Sick:</span>
                                    <span v-if="details.male.sick>=0">{{details.male.sick}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div style="display: flex; gap: 20px; font-size: medium;">
                                    <span style="width: 100px;">Disability:</span>
                                    <span v-if="details.male.disabled>=0">{{ details.male.disabled }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p style="display: flex; gap: 20px; font-size: medium; font-weight: 500;">Female</p>
                        <div class="row mt-2">
                            <div class="col-sm-12">
                                <div style="display: flex; gap: 20px; font-size: medium;">
                                    <span style="width: 100px;">Good:</span>
                                    <span v-if="details.female.good>=0">{{details.female.good}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div style="display: flex; gap: 20px; font-size: medium;">
                                    <span style="width: 100px;">Sick:</span>
                                    <span v-if="details.female.sick>=0">{{details.female.sick}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div style="display: flex; gap: 20px; font-size: medium;">
                                    <span style="width: 100px;">Disability:</span>
                                    <span v-if="details.female.disabled>=0">{{ details.female.disabled }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import Multiselect from 'vue-multiselect';
    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import 'sweetalert2/src/sweetalert2.scss'
    import loader from '../loader/loader.vue';
    export default {
        components: {
            vueDropzone: vue2Dropzone,
            Datepicker,
            Multiselect,
            loader
        },
    
        data() {
            return {
                demographic_title: null,
                details:{
                    good:null,
                    sick:null,
                    disabled:null,
                    pregnant:null,
                }
            }
        },
    
        computed: {
            ...mapState({
                count_list: state => state.dashboard.dashboard_count,
                demographic_count :state => state.dashboard.demographic_count,
                loading:state => state.dashboard.dashboardCountLoading,
                error:state => state.dashboard.dashboardCountError,
            }),

          
        },
    
        mounted() {
            this.$store.dispatch("dashboard/fetchDashboardCount")
           
           
        },
    
        methods: {
            getDemographic(demo) {
                this.demographic_title = demo
                if(demo === 'Male'){
                    this.$store.dispatch("dashboard/fetchDashboardDemographicCount").then((response) => {
                        this.details = response.data.male
                    });
                }
                else if(demo === 'Female'){
                    this.$store.dispatch("dashboard/fetchDashboardDemographicCount").then((response) => {
                        this.details = response.data.female
                    });
                }
                else if(demo === 'Children'){
                    this.$store.dispatch("dashboard/fetchDashboardDemographicCount").then((response) => {
                        this.details = response.data.child
                    });
                }
            }
        }
    };
</script>

<style scoped>
.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large; 
    font-weight: 500; 
    color: #fc9d3f;
}

.count {
    text-align: end; 
    font-size: xx-large; 
    font-weight: 500; 
    padding-right: 28px;
}

.main-title {
    font-size: x-large; 
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large; 
        font-weight: 500;
    }
}

@media (max-width: 768px) {
    .count {
       padding-right: 12px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
    